"use client";

import { useEffect, useMemo } from "react";
import MainLayout from "@components/Layout/Layout";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { useAppContext } from "@components/Provider";
import TagManager from "react-gtm-module";
import Post from "src/constants/Post";
import { isEbbHomepage } from "@components/HomePage/ebbHomepageUtils";

const PostPageLayout = ({ children, postType, postComponents, adSettings, hideHeader }) => {
  const { data, siteId, isMobile, subscriberCookie, isNonClosableModalChecked, setNewValue } =
    useAppContext();
  const isHomepageLanding = isEbbHomepage(postType);

  const SelectedLayout = useMemo(() => {
    let layout = MainLayout;
    const PostTypes = [
      Post.TYPES.PAGE,
      Post.TYPES.DEALS,
      Post.TYPES.LANDING_DEALS,
      Post.TYPES.FUNNEL,
      Post.TYPES.CATEGORY_FUNNEL,
      Post.TYPES.GIVEAWAY_PAGE,
      Post.TYPES.TELL_A_FRIEND_PAGE,
      Post.TYPES.INTEREST_PAGE,
      Post.TYPES.YOUNG_BOOK_READER,
      Post.TYPES.EBB_HOMEPAGE,
      Post.TYPES.HOMEPAGE,
    ];

    if (isHomepageLanding || PostTypes.includes(postType)) {
      layout = SingleColumnLayout;
    }
    return layout;
  }, [postType, isHomepageLanding]);

  useEffect(() => {
    TagManager.initialize({
      gtmId: data.SiteSettings.gtm_container_id,
    });

    const newIsNonClosableModalChecked =
      isMobile &&
      (postComponents || []).filter((el) => {
        if (el && el?.type === "newsletter") {
          return el.props.nonClosableModalProps;
        }
        if (el && el?.type === "newsletter-v2") {
          return el.props.modalProps.nonClosableModal;
        }
      });
    if (
      Array.isArray(newIsNonClosableModalChecked) &&
      isNonClosableModalChecked !== newIsNonClosableModalChecked &&
      newIsNonClosableModalChecked.length > 0
    ) {
      setNewValue({ isNonClosableModalChecked: true });
    }
  }, []);

  const otherData = {
    siteId,
    isMobile,
    subscriberCookie,
    isNonClosableModalChecked,
    adSettings,
    hideHeader: hideHeader || isHomepageLanding,
    postType,
    hideSiteChrome: isHomepageLanding,
    hideNewsletter: isHomepageLanding,
  };

  return <SelectedLayout {...otherData}>{children}</SelectedLayout>;
};

export default PostPageLayout;
